import React from 'react';
import memoizeOne from 'memoize-one';

interface PathProps {
  d: string;
  fillRule?: 'nonzero' | 'evenodd' | 'inherit';
  clipRule?: 'nonzero' | 'evenodd' | 'inherit';
  id: string;
}

const ICON_PATHS: PathProps[] = [
  {
    id: 'path-1',
    d: 'M24 4q.99 0 1.96.1l-.15 1.49-.14 1.49q-.42-.04-.83-.06L24 7a17 17 0 0 0 0 34l.84-.02'
      + 'q.42-.02.83-.06l.14 1.5.15 1.48q-.48.05-.98.08L24 44a20 20 0 1 1 0-40M32.72 40.32l.71 1.32a20 20 0 0 1-3.62'
      + ' 1.5l-.44-1.43-.43-1.44A17 17 0 0 0 32 39zM39.46 36.69a20 20 0 0 1-2.77 2.77l-1.9-2.32q1.3-1.06 2.35-2.35z',
  },
  {
    id: 'path-2',
    d: 'M15.4 14.34c.83 0 1.5.67 1.5 1.5v16.32a1.5 1.5 0 0 1-3 0V15.84c0-.83.67-1.5 1.5-1.5M21.4 14.34c.82 0 1.5.67 1.5 1.5v16.32a1.5'
      + ' 1.5 0 0 1-3 0V15.84c0-.83.67-1.5 1.5-1.5M26.89 15.37a1.5 1.5 0 0 1 1.91.9l5.47 15.4a1.5 1.5 0 1 1-2.82 1l-5.47-15.39a1.5'
      + ' 1.5 0 0 1 .9-1.91M41.7 29.37l1.44.44a20 20 0 0 1-1.5 3.62l-1.32-.7L39 32q.79-1.46 1.27-3.07zM43.9 22.04a20 20 0 0 1 0 3.92l'
      + '-1.49-.15-1.49-.14a17 17 0 0 0 0-3.34l1.5-.14zM41.64 14.57a20 20 0 0 1 1.5 3.62l-1.43.44-1.44.43A17 17 0 0 0 39 16l1.32'
      + '-.71zM36.69 8.54q1.52 1.25 2.77 2.77l-2.32 1.9q-1.06-1.3-2.35-2.35zM29.8 4.86q1.9.58 3.63 1.5l-.7 1.32L32 9q-1.46-.79-3.07'
      + '-1.27l.43-1.44z',
  },
];

export const simResourceIcon = memoizeOne((iconClass: string, iconWrapperClass: string, size?: string) => {
  const svgSize = size || '1x';
  return (
    <div className={iconWrapperClass || ''}>
      <svg
        name="simulation-resource"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        fill="currentColor"
        width="1rem"
        height="1rem"
        className={`o-els-icon-svg--${svgSize} u-els-display-block ${!iconWrapperClass ? 'u-els-margin-top-1o4' : ''} ${iconClass || ''}`}
      >
        {ICON_PATHS.map((path) => (
          <path
            key={path.id}
            d={path.d}
            {...(path.fillRule && { fillRule: path.fillRule })}
            {...(path.clipRule && { clipRule: path.clipRule })}
          />
        ))}
      </svg>
    </div>
  );
});
